import { render, staticRenderFns } from "./AlertGroup.vue?vue&type=template&id=73af7496&scoped=true&"
import script from "./AlertGroup.vue?vue&type=script&lang=ts&"
export * from "./AlertGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AlertGroup.vue?vue&type=style&index=0&id=73af7496&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af7496",
  null
  
)

export default component.exports